import { Throwable, ThrowableStatus } from "@wss/error-tracking/throwable";
import { toError } from "@wss/error-tracking/utils";
import { PlusStatus } from "./plusStatus";

const fetchCurrentUserPlusStatus = async (): Promise<
  ThrowableStatus<PlusStatus | null>
> => {
  try {
    const url = new URL("/myaccount/spa/plusstatus/", window.location.origin);
    const response = await fetch(url, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      return {
        isError: true,
        status: response.status,
        error: new Error(response.statusText),
      };
    }

    const data = await response.json<PlusStatus>();

    return { isError: false, value: data };
  } catch (error) {
    return {
      isError: true,
      status: null,
      error: new Error(
        "There was an error with the '/myaccount/spa/plusstatus/' endpoint",
        { cause: error }
      ),
    };
  }
};

export default fetchCurrentUserPlusStatus;
